import { ApiResult, request, safeRequest } from '@synergy/api';
import { Tag } from '@synergy/models';

import { ConfigurationTag } from '../../features/configuration/data/tags/models/configuration-tag';

export class TagApi {
    constructor(protected baseUrl: string) {}

    public getAll(params?: URLSearchParams): Promise<ApiResult<Tag[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/all-tags`, { params }),
            response => response.data
        );
    }

    public getAllConfigurationTags(params?: URLSearchParams): Promise<ApiResult<ConfigurationTag[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/tags`, { params }),
            response => response.data
        );
    }

    public deleteConfigurationTag(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/tags/${id}`),
            () => null
        );
    }

    public post(tag: Partial<ConfigurationTag>): Promise<ApiResult<ConfigurationTag>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/tags`, tag),
            response => response.data
        );
    }

    public updateConfigurationTag(
        id: number,
        tag: Partial<ConfigurationTag>
    ): Promise<ApiResult<ApiResult<ConfigurationTag>>> {
        const changedTag = { ...tag };
        delete changedTag.id;

        return safeRequest(
            () => request.patch(`${this.baseUrl}/tags/${id}`, changedTag),
            response => response.data
        );
    }
}
